import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './src/contexts/IframeAuthContext';
import LoginPage from './src/pages/LoginPage';
import CallbackPage from './src/pages/CallbackPage';
import { CasesHomePage } from './src/pages/CasesHomePage';
import { CaseEditorPage } from './src/pages/CaseEditorPage';
import { DictionaryPage } from './src/pages/DictionaryPage';
import { LoadingPage } from './src/pages/LoadingPage';
import { AuthGuard } from '@shared/auth/AuthGuard';
import { Agentation } from 'agentation';

function App() {
  const auth = useAuth();

  return (
    <>
    <AuthGuard
      appName="RedactIt"
      appLogo="/propalyst-logo.svg"
      rolePrefix="redactit"
      defaultRedirect="/"
      auth={auth}
      darwinLoginUrl={import.meta.env.VITE_DARWIN_LOGIN_URL}
      loadingComponent={
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading...</p>
          </div>
        </div>
      }
    >
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/callback" element={<CallbackPage />} />

        {/* Protected routes */}
        <Route path="/" element={<CasesHomePage />} />
        <Route path="/cases/:caseId" element={<CaseEditorPage />} />
        <Route path="/dictionary" element={<DictionaryPage />} />
        <Route path="/loading" element={<LoadingPage />} />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthGuard>
    {import.meta.env.VITE_AGENTATION === 'true' && <Agentation className="agentation-toolbar" />}
    </>
  );
}

export default App;